"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _uigCurrentEnvironmentUtil = require("@sfly/uig-current-environment-util");

var _constants = require("../../constants");

var Utils = /*#__PURE__*/function () {
  function Utils() {
    (0, _classCallCheck2.default)(this, Utils);
  }

  (0, _createClass2.default)(Utils, null, [{
    key: "getEnvPrefix",
    // this will return env prefix
    value: function getEnvPrefix() {
      var env = (0, _uigCurrentEnvironmentUtil.getCurrentEnv)();

      if (env === 'production') {
        return '';
      }

      return "".concat(env, ".");
    }
  }, {
    key: "getHostName",
    value: function getHostName(brand) {
      if (brand === _constants.BRANDS.TINYPRINTS) {
        return "//wwww.".concat(Utils.getEnvPrefix(), "tinyprints.com");
      } else {
        return "//www.".concat(Utils.getEnvPrefix(), "shutterfly.com");
      }
    }
  }, {
    key: "filterKeyPress",
    value: function filterKeyPress(event) {
      var keyCodesMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [keyCodesMap.enter];
      return keyCodesMap.includes(event.which) || keyCodesMap.includes(event.keyCode) || keyCodesMap.includes(event.charCode);
    } // prevents the default behaviour of and handles the key press
    // for keys mentioned under keyCodesToHandle defined at top in this class

  }, {
    key: "handleSpaceKeyPress",
    // // prevents the default behaviour of and handles the 'Enter' key press
    // static handleKeyPress(e = {}, cb = () => {}) {
    //     if (e.which === 13 || e.keyCode === 13) {
    //         e.preventDefault();
    //         cb(e);
    //     }
    // }
    value: function handleSpaceKeyPress() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

      if (e.which === 32 || e.charCode === 32) {
        e.preventDefault();
        cb(e);
      }
    }
  }, {
    key: "generateKey",
    value: function generateKey() {
      var pre = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'key';
      return "".concat(pre, "_").concat(new Date().getTime());
    }
    /**
     * Gets SFLY host name  based on current brand you are on
     * @param { brand:  the current brand value }
     * @return: string : the base url
     */

  }, {
    key: "getSFLYHostNameBasedonBrand",
    value: function getSFLYHostNameBasedonBrand(brand) {
      return brand === _constants.BRANDS.SHUTTERFLY || brand === _constants.BRANDS.INC ? '' : "https:".concat(Utils.getHostName(_constants.BRANDS.SHUTTERFLY));
    }
  }, {
    key: "isValidArray",
    value: function isValidArray(obj) {
      return (0, _isArray.default)(obj) && obj.length > 0;
    }
  }]);
  return Utils;
}();

exports.default = Utils;
(0, _defineProperty2.default)(Utils, "keyCodeMap", {
  enter: 13,
  escape: 27,
  space: 32,
  arrowLeft: 37,
  arrowUp: 38,
  arrowRight: 39,
  arrowDown: 40,
  tab: 9
});
(0, _defineProperty2.default)(Utils, "keyCodesToHandle", [Utils.keyCodeMap.enter, Utils.keyCodeMap.space]);
(0, _defineProperty2.default)(Utils, "handleKeyPress", function () {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  var keyCodesMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Utils.keyCodesToHandle;
  var isPreventDefault = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  if (Utils.filterKeyPress(e, keyCodesMap)) {
    if (isPreventDefault) {
      e.preventDefault();
    }

    cb(e);
  }
});